import {
  AIEXP_ABI,
  AIEXP_ADDRESS,
  BOO_CONTRACT_ADDRESS,
  CONTRACT_ABI,
  CONTRACT_ADDRESS,
  DAOPASS_ADDRESS,
  GHOST_OG_STAKING_ADDRESS,
  GOG_ABI,
  GOG_ADDRESS,
  MUTANTS_ABI,
  MUTANTS_ADDRESS,
  ULTIMATE_ABI,
  ULTIMATE_ADDRESS,
} from "../config";

export type CollectionType = {
  collectionName: string;
  collectionAddress: string;
  rewardToken: string;
  rewardTokenAddress: string;
  abi: any;
  rate: number;
  perNFT?: boolean;
  baseUrl: string;
};

const Collections: CollectionType[] = [
  {
    collectionName: "Ghost OG NFT",
    collectionAddress: GOG_ADDRESS,
    rewardTokenAddress: BOO_CONTRACT_ADDRESS,
    rewardToken: "$BOO",
    rate: 10,
    perNFT: true,
    abi: GOG_ABI,
    baseUrl: "bafybeifntcx4ddc5gptglsp35kl5kmunxcdmmacnh2uw3uhrvoglsr47li",
  },
  {
    collectionName: "Dr Dao X Mutant",
    collectionAddress: MUTANTS_ADDRESS,
    rewardTokenAddress: "0x3E52e3c3F805623Bec8d30c2A6e8aa508751443c",
    rewardToken: "Daolab Token",
    rate: 0.5,
    abi: MUTANTS_ABI,
    baseUrl: "bafybeievituojkz6qnhyuufufsjlljkrructwj5yss7mfrymp4hacesxda",
  },
  {
    collectionName: "AI Labs",
    collectionAddress: CONTRACT_ADDRESS,
    rewardToken: "DaoLab Token",
    rewardTokenAddress: "0x3E52e3c3F805623Bec8d30c2A6e8aa508751443c",
    rate: 0.25,
    abi: CONTRACT_ABI,
    baseUrl: "bafybeigk5aakyzyxe36lczjtrqontbusk4artnezzzoe5b4ymclgsz7fwe",
  },
  {
    collectionName: "AI Experiments",
    collectionAddress: AIEXP_ADDRESS,
    rewardToken: "DaoLab Token",
    rewardTokenAddress: "0x3E52e3c3F805623Bec8d30c2A6e8aa508751443c",
    rate: 0.25,
    perNFT: true,
    abi: AIEXP_ABI,
    baseUrl: "bafybeie2sjqpuni5vwd6szlyzmpx3iqqgogstwhokys74il44ja6jijq6q",
  },
  {
    collectionName: "Daolist Pass 3D",
    collectionAddress: DAOPASS_ADDRESS,
    rewardToken: "DaoLab Token",
    rewardTokenAddress: "0x3E52e3c3F805623Bec8d30c2A6e8aa508751443c",
    rate: 0.5,
    abi: AIEXP_ABI,
    baseUrl: "bafybeidv5sayxhtqqclcgx4jbd3dmreocah7auszsxypv5kgmwvd6akkc4",
  },
  {
    collectionName: "Ultimate X Mutants",
    collectionAddress: ULTIMATE_ADDRESS,
    rewardToken: "DaoLab Token",
    rewardTokenAddress: "0x3E52e3c3F805623Bec8d30c2A6e8aa508751443c",
    rate: 0.5,
    abi: ULTIMATE_ABI,
    baseUrl: "bafybeidvw7ycqg5hapq7f735kwk2xvoce3s43lsk3ycvn4xr2k5ts3bcvi",
  },
];

export default Collections;
